module.exports = __webpack_public_path__ + "img/superheroes-iphone-02.49eb0275.png";